// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../header/Header';
import Footer from '../footer/Footer';

const Layout = () => {
  return (
    <div className="labelflow-theme">
      <Header />
      <main className="labelflow-main">
        <div className="pcoded-main-container labelflow-container">
          <Outlet />
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;